export const CameraFillIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7301_8794)">
                <path
                    d="M12 4.5V11.5C12 11.7652 11.8946 12.0196 11.7071 12.2071C11.5196 12.3946 11.2652 12.5 11 12.5H2C1.73478 12.5 1.48043 12.3946 1.29289 12.2071C1.10536 12.0196 1 11.7652 1 11.5V4.5C1 4.23478 1.10536 3.98043 1.29289 3.79289C1.48043 3.60536 1.73478 3.5 2 3.5H11C11.2652 3.5 11.5196 3.60536 11.7071 3.79289C11.8946 3.98043 12 4.23478 12 4.5ZM15.625 4.51562C15.5545 4.49836 15.4811 4.49623 15.4096 4.50938C15.3382 4.52252 15.2704 4.55063 15.2106 4.59188L13.1112 5.99125C13.077 6.0141 13.0489 6.04505 13.0295 6.08136C13.0101 6.11767 13 6.15821 13 6.19938V9.80062C13 9.84179 13.0101 9.88233 13.0295 9.91864C13.0489 9.95495 13.077 9.9859 13.1112 10.0087L15.2225 11.4163C15.3015 11.469 15.3939 11.4981 15.4889 11.5002C15.5839 11.5023 15.6775 11.4773 15.7587 11.4281C15.834 11.3803 15.8956 11.314 15.9379 11.2356C15.9801 11.1571 16.0015 11.0691 16 10.98V5C16.0001 4.88911 15.9632 4.78135 15.8954 4.69366C15.8275 4.60598 15.7324 4.54335 15.625 4.51562Z"
                    fill="#3B82F6"
                />
            </g>
            <defs>
                <clipPath id="clip0_7301_8794">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
